<cx-navigation-ui
  [node]="node$ | async"
  [ngClass]="(styleClass$ | async) ?? ''"
  [navAriaLabel]="name$ | async"
>
</cx-navigation-ui>
